export const Spinner = () => {
  return (
    <svg
      width='40'
      height='40'
      viewBox='0 0 40 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M40 20C40 31.0457 31.0457 40 20 40C8.9543 40 0 31.0457 0 20C0 8.9543 8.9543 0 20 0C31.0457 0 40 8.9543 40 20ZM3.00753 20C3.00753 29.3847 10.6153 36.9925 20 36.9925C29.3847 36.9925 36.9925 29.3847 36.9925 20C36.9925 10.6153 29.3847 3.00753 20 3.00753C10.6153 3.00753 3.00753 10.6153 3.00753 20Z'
        fill='#D9D9D9'
      />
      <path
        d='M40 20C40 17.3736 39.4827 14.7728 38.4776 12.3463C37.4725 9.91982 35.9993 7.71504 34.1421 5.85786C32.285 4.00069 30.0802 2.5275 27.6537 1.52241C25.2272 0.517315 22.6264 -1.14805e-07 20 0V3.00753C22.2315 3.00753 24.4411 3.44706 26.5027 4.30101C28.5644 5.15496 30.4376 6.40662 32.0155 7.98451C33.5934 9.56241 34.845 11.4356 35.699 13.4973C36.5529 15.5589 36.9925 17.7685 36.9925 20H40Z'
        fill='#00104A'
      />
      <circle cx='19.9745' cy='1.51282' r='1.51282' fill='#00104A' />
      <circle cx='38.4616' cy='19.9994' r='1.53846' fill='#00104A' />
    </svg>
  )
}
export const Logo = () => {
  return (
    <svg
      width='80'
      height='109'
      viewBox='0 0 80 109'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M3.45264 81.0442H20.9467V0.00292969H7.11786C5.09468 0.00926451 3.45582 1.64359 3.45582 3.66123V81.0442H3.45264Z'
        fill='#00104B'
      />
      <path
        d='M59.5172 46.5194C61.3848 48.4167 62.5377 51.0172 62.5377 53.8837C62.5377 59.6959 57.8117 64.409 51.9835 64.409C46.1553 64.409 41.5754 59.8352 41.4356 54.1433H23.9702C24.11 69.4546 36.5984 81.8234 51.9835 81.8234C67.3686 81.8234 80 69.3153 80 53.8837C80 46.2059 76.8905 39.2534 71.8659 34.2046L59.5172 46.5194Z'
        fill='#00104B'
      />
      <path d='M78.1958 0H24.853V16.6416H78.1958V0Z' fill='#EC1F80' />
      <path
        d='M61.4959 16.6413L44.8563 33.2354C43.7224 34.3661 43.7224 36.1968 44.8563 37.3244L54.6037 47.0453L78.1959 23.5177V16.6382H61.4959V16.6413Z'
        fill='#00104B'
      />
      <path
        d='M50.4463 85.9346V100.736C50.4463 102.225 49.233 103.435 47.7403 103.435H45.1073V85.9503L38.8472 85.9346V103.435H33.5716V85.9503L27.3115 85.9346V108.993L48.258 109C52.9173 109 56.7096 105.215 56.7096 100.568V85.9536L50.4495 85.9377L50.4463 85.9346Z'
        fill='#00104B'
      />
      <path
        d='M75.7502 85.9346H59.1328V91.506H71.5355V108.99H77.7956V87.9744C77.7956 86.8499 76.8778 85.9346 75.7502 85.9346Z'
        fill='#00104B'
      />
      <path
        d='M22.6012 85.9351L3.46197 85.9287C3.44926 89.34 3.45561 99.045 3.45561 102.456C3.45561 103.02 3.33809 103.128 2.75686 103.125H0V108.956C1.45148 108.943 3.32538 108.968 4.77686 108.937C5.23105 108.927 5.69476 108.835 6.12989 108.702C7.9371 108.151 9.90629 106.089 9.84594 103.492V91.5065H18.3865V108.991H24.6466V87.9748C24.6466 86.8504 23.7287 85.9351 22.6012 85.9351Z'
        fill='#00104B'
      />
    </svg>
  )
}
